import { Button, Dialog, Icon, Text } from '@ui-component-library';

import { ConfirmClosePopupProps } from '../Checkout.types';

export function ConfirmClosePopup({ isOpen, setIsOpen, handleClose }: ConfirmClosePopupProps) {
  return (
    <Dialog isOpen={isOpen} size="small">
      <Dialog.Header>
        <div className="flex w-full justify-between">
          <Text variant="text-lg/leading-none/medium">Vill du avbryta?</Text>
          <Button variant="tertiary" size="icon" onClick={() => setIsOpen(false)}>
            <Icon name="CrossSimple" className="color-charcoal-500" size="large" />
          </Button>
        </div>
      </Dialog.Header>
      <Dialog.Content>
        <Text variant="text-sm/leading-normal/normal">
          Dina ändringar kommer inte att sparas om du avbryter nu.
        </Text>
      </Dialog.Content>
      <Dialog.Footer>
        <Button variant="secondary" onClick={() => setIsOpen(false)}>
          Nej, stanna kvar
        </Button>
        <Button variant="primary" onClick={handleClose}>
          Ja, stäng
        </Button>
      </Dialog.Footer>
    </Dialog>
  );
}
